
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { AudioPlaylistEntry } from "../interfaces/playlist";
import { PlayerActions } from "../store/store.actions";
import { PlayerGetters } from "../store/store.getters";
import { urlParamService } from "@/services/urlParam.service";

@Component({})
export default class MediaControls extends Vue {
  name = "MediaControls";
  playerMuted = true;
  @Prop() show?: boolean;

  @Action(PlayerActions.toggleFullscreen) toggleFullscreen!: () => void;
  @Action(PlayerActions.togglePaused) togglePaused!: () => void;
  @Action(PlayerActions.toggleMuted) toggleMuted!: () => void;
  @Action(PlayerActions.triggerPlaylistEntry) triggerPlaylistEntry!: ({
    prev,
    triggered,
  }: {
    prev: boolean;
    triggered: boolean;
  }) => Promise<void>;

  @Getter(PlayerGetters.audioPlaylist) audioPlaylist!: AudioPlaylistEntry[];
  @Getter(PlayerGetters.paused) paused!: boolean;
  @Getter(PlayerGetters.totalTime) totalTime!: number;
  @Getter(PlayerGetters.currentTime) currentTime!: number;
  @Getter(PlayerGetters.muted) muted!: boolean;

  get progressBarValue() {
    return (this.currentTime / this.totalTime) * 100;
  }

  get allowFullScreen() {
    return urlParamService.allowFullscreen;
  }

  get hideProgressBar() {
    return urlParamService.hideProgressBar;
  }

  get hideMediaControls() {
    return urlParamService.isAppPlayer;
  }

  get isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;
  }
}
